import React from "react";
import FileCommentComponent from "../../comments/file-comment";
import { useParams } from "react-router-dom";

const LeadFileCommentsLits = () => {
  const { id } = useParams();
  return (
    <main>
      <FileCommentComponent tableName={"lead"} viewId={id} />
    </main>
  );
};

export default LeadFileCommentsLits;
